export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: "f1",
    question: "爆料91专区到底是什么？和普通分类页有什么区别？",
    answer:
      "爆料91专区不是简单的分类列表，而是把同一类内容按合集重新组织过的入口。一个专区对应一整块内容，进入之后就能看到该方向下所有期数的整理，不需要在多个页面之间来回翻。",
  },
  {
    id: "f2",
    question: "专区、栏目、频道、板块这几个说法是一回事吗？",
    answer:
      "在日常使用中它们指的都是内容的归类方式，只是颗粒度不同。频道偏大，栏目偏中，板块和专区偏细。我们在网站上统一以「专区」作为入口名称，内部再按栏目和板块细分，避免概念太杂让人迷路。",
  },
  {
    id: "f3",
    question: "内容合集会更新吗，多久整理一次？",
    answer:
      "热门方向基本保持每日更新，更新频率较低的方向按周整理。每次更新都会在合集页标注最新整理日期，你可以通过标注快速判断这块内容是不是新的。",
  },
  {
    id: "f4",
    question: "为什么有的内容只有摘要，看不到完整正文？",
    answer:
      "出于版权和合规考虑，部分内容我们只保留导读与要点梳理，完整内容会指向原始出处。我们更希望做的是帮你快速判断「值不值得看」，而不是把所有原文都搬运过来。",
  },
  {
    id: "f5",
    question: "可以按自己的兴趣订阅某个专区吗？",
    answer:
      "目前可以通过收藏专区页面的方式自行关注，浏览器书签即可实现。后续我们会考虑加入更轻量的关注方式，让你打开网站就能直接看到常看的几个专区。",
  },
  {
    id: "f6",
    question: "内容里涉及的剧集、节目名称都是真实存在的吗？",
    answer:
      "网站上出现的作品名称、人物与情节均为便于说明栏目结构的设定内容，不指向任何真实作品或个人。我们不发布、也不整理任何涉及具体个人隐私的信息。",
  },
  {
    id: "f7",
    question: "如何向我们反馈内容问题或提供线索？",
    answer:
      "可以通过「关于我们」页面留下的编辑邮箱联系我们。如果是内容纠错，请附上页面名称和具体位置；如果是线索建议，简单说明方向即可，我们会安排对应的栏目编辑跟进。",
  },
];